module.exports = __webpack_public_path__ + "a22143d3b0294cd8ef26dffbf6df3988.otf";